var $77cae902215c3895$exports = {};
$77cae902215c3895$exports = {
    "maximum": `Maksimum`,
    "minimum": `Minimum`
};


export {$77cae902215c3895$exports as default};
//# sourceMappingURL=da-DK.mjs.map
